import type { LegacyQuotePagesPath } from 'app/home/common/services/legacy/quote-pages';

/**
 * Form key -> the v1 API path that renders that form.
 *
 * This deliberately lives apart from `quote-form.config.ts`. That module imports all
 * twenty form components, and those components import the global stores, so anything
 * needing only the key/path relationship — `QuoteFormOptionsStore` in particular — used
 * to drag the whole component graph in and form an import cycle. Under the Vitest bundle
 * that cycle resolved with `BaseQuoteForm` still undefined when the form components
 * evaluated their `extends` clause, so their specs could not load at all.
 *
 * Each entry must match the `legacyShape` its component passes to
 * `QuoteFormContextDecorator`. `tests/quote-form-legacy-paths.spec.ts` asserts that, so
 * the two cannot drift apart silently.
 */
export const quoteFormLegacyPaths = {
  'about-you': '/quote/about-you',
  'policy-type': '/quote/policy_type',
  'unit-number-check': '/quote/unit_number_check',
  'unit-number-entry': '/quote/unit_number_entry',
  'insurance-status': '/quote/insurance_status',
  'rental-status': '/quote/rental_status',
  'rental-number': '/quote/rental_status_number',
  residency: '/quote/residency',
  'policy-start-date': '/quote/policy_start_date',
  'co-applicant': '/quote/co-applicant',
  'co-applicant-info': '/quote/co-applicant-info',
  'property-type': '/quote/property-details/property-type',
  'roof-shape': '/quote/property-details/roof-shape',
  'insurance-expiration': '/quote/insurance_status_days',
  'year-built': '/quote/property-details/year-built',
  'construction-type': '/quote/property-details/construction-type',
  'roof-year': '/quote/property-details/roof-year',
  'exterior-wall': '/quote/property-details/exterior-wall',
  'property-information': '/quote/property_information',
  foundation: '/quote/property-details/foundation',
} as const satisfies Record<string, LegacyQuotePagesPath>;

export type QuoteFormMappingKey = keyof typeof quoteFormLegacyPaths;
